const actionTypes = {
  FetchUserByUid: 'FETCH_USER_BY_UID',
  FetchedReservations: 'FETCH_RESERVATIONS',
  Initialize: 'INITIALIZE',
  LoadCurrentOrder: 'LOAD_CURRENT_ORDER',
  LoadOrderSetup: 'LoadOrderSetup',
};

export default actionTypes;
